import axios from "axios";
import React, { useEffect, useState } from "react";

export const useGetTeamsFromGroups = ({tournamnetId})=>{
        const [allTeamsByGroup, setAllTeamsByGroup] = useState('')
    
        const fetchAllTeamsByTournament = async ()=>{
        const urlTeams = 'https://web-production-58ed.up.railway.app/api/dt/getteams/bytorneo';
        try {
          const teams = await axios.post(urlTeams,{torneo: tournamnetId})
          const allTeams = teams?.data?.positionTeams;
          const teamsByGroup = {}

          allTeams?.forEach(team => {
            if(teamsByGroup[team?.grupo]){
                teamsByGroup[team?.grupo] = [...teamsByGroup[team?.grupo], team]

            }else{
                teamsByGroup[team?.grupo] = [team]
            }
          });
          setAllTeamsByGroup(teamsByGroup)
            
        } catch (error) {
            
        }

    }
 
    useEffect(()=>{
        fetchAllTeamsByTournament()

    },[])

    return { allTeamsByGroup }

}